import { z } from 'zod';
import { GeneralType } from '@/common/utils';

const [firstType, ...otherTypes] = Object.keys(GeneralType).map(it => it.toLowerCase());

export const GeneralFilter = z.object({
  page: z.number().catch(1),
  type: z.enum([firstType, ...otherTypes]).catch(firstType),
  onlyEnabled: z.boolean().default(true),
  keyword: z.string().default(''),
  definitionLanguage: z.string().nullable().default(''),
});
export type GeneralFilterType = z.infer<typeof GeneralFilter>;
